












import { defineComponent, ref, computed, onMounted } from '@vue/composition-api';
import { i18n } from '@/i18n';
import { storeToRefs } from 'pinia';
import { useStampStore } from '@/store/stamp';
import { biClick } from '@tencent/fit-bi-sdk';
import { useLogin } from '@/store/login';
import { to } from '@tencent/wphk-base-utils';
import { useGlobalData } from '@/hooks/use-global-data';
import { CustomException } from '@tencent/ppd-base-libs';
import { showBusinessError } from '@tencent/wphk-components-dialog';
import { hideLoading, showLoading } from '@tencent/wphk-act-base-ui';
import WxSubscribe from '@tencent/wphk-components-wx-subscribe/index.vue';
import { useSubscribe } from '@/hooks/use-subscribe';

export default defineComponent({
  name: 'DonationBtn',
  components: {
    WxSubscribe,
  },
  props: {
    btnText: {
      type: String,
      default: i18n('捐贈'),
    },
    item: {
      reuqired: true,
      type: Object,
      default: () => ({ key: '' }),
    },
    showIcon: {
      type: Boolean,
      default: false,
    },
    extDonationScenes: {
      type: String,
      default: '',
    },
  },
  setup(props, { emit }) {
    const stampStore = useStampStore();
    const { userStampInfo, globalActInfo, currentNGO } = storeToRefs(stampStore);
    const disabledClass = computed(() => {
      if (userStampInfo.value.intervalAvailableCnt <= 0) {
        return 'disabled';
      }
      return '';
    });
    const loginStore = useLogin();
    const isDonating = ref(false);
    const { highAuthLogin } = storeToRefs(loginStore);
    const globalActInfoVal = computed(() => globalActInfo.value); // 总活动信息
    // 捐赠成功次数
    const successCount = ref(0);
    // 捐赠执行次数
    const runCount = ref(0);
    const isOverLimit = ref(false);
    const { showWxSubscribe, handleSubscribeRes, isSubscribed, tplIds } = useSubscribe();

    // 刷新页面
    const refresh = () => {
      // 刷新数据（静默）
      const globalData = useGlobalData();
      globalData.refresh();
    };

    onMounted(() => {
      // 登录返回后后续的操作
      highAuthLogin.value.afterHighAuthLogin(donateStamp);
    });

    const handleExchange = async (ngo: any) => {
      /**
       * 1. 需要先prom_exchange_prize.cgi进行访问总限额的活动派发活动，给用户派发资格
       * 如果失败，则不进行操作（如果失败，说明用户当日已经捐贈，或者当日捐贈总数已达到15000）
       * 2. 如果成功，prom_exchange_prize.cgi 兑换活动，对应给ngo的捐贈活动
       * ---
       * 1. 第一次调用成功，第二次调用失败，这时候会算入日限额当日已捐贈和日限额累计已捐贈数
       * 2. 第一次调用成功，第二次调用失败，用户就算有印花也不能再次捐贈。。
       */

      runCount.value = runCount.value + 1;

      if (globalActInfoVal.value.totalSendNum >= globalActInfoVal.value.totalLimit) {
        isOverLimit.value = true;
        runQueue(ngo);
        return;
      }

      const [err] = await to(stampStore.exchangePrize(globalActInfoVal.value.enActid, globalActInfoVal.value.prizeId));

      if (err) {
        runQueue(ngo);
        return;
      }
      // 1039169066  –    无效的act_id
      // 1039169100  –    输入参数qual_id无效
      // 1039169302  –    兑换失败，可重试
      // 1039169510   –   频率限制拦截，用户已使用其他批次印花兑换过
      // 1039169511   –   相同批次印花重复兑换
      // 1039169512   –   兑换限额（如日限额）触发
      const [errNgo] = await to(stampStore.exchangePrize(ngo.enActid, ngo.prizeId));
      if (errNgo) {
        runQueue(ngo);
        return;
      }
      successCount.value = successCount.value + 1;
      runQueue(ngo);
    };

    // 重置数据
    const resetData = function (ngo: any) {
      runCount.value = 0;
      successCount.value = 0;
      ngo.donateCount = 1;
      refresh();
      emit('donationComplete');
    };

    const completeHandle = function (ngo: any) {
      isDonating.value = false;
      hideLoading();
      if (isOverLimit.value) {
        showBusinessError(i18n('捐贈超過本期上限，本次成功捐贈x朵小紅花', { num: successCount.value }));
        resetData(ngo);
        return;
      }
      const failCount = ngo.donateCount - successCount.value;
      if (failCount > 0) {
        showBusinessError(i18n('已成功捐贈x朵小紅花，y朵捐贈失敗', { num1: successCount.value, num2: failCount }));
        resetData(ngo);
        throw new CustomException(null, 'goodDeedDayExchangeFail', failCount === ngo.donateCount ? '全部捐赠失败' : '部分捐赠失败');
      }
      sessionStorage.setItem('currentNGOName', ngo.name);
      resetData(ngo);
      emit('donationSucc', ngo);
    };

    // 执行捐赠
    const runQueue = async (ngo: any) => {
      if (isOverLimit.value || runCount.value >= ngo.donateCount) {
        completeHandle(ngo);
        return;
      }
      await handleExchange(ngo);
    };

    const donateStamp =  async (ngo: any) => {
      // 埋点上报
      biClick('donation-btn.click|捐赠点击', {
        fngo_item_name: ngo.name,
        fdonation_scenes: props.extDonationScenes,
      });
      // 先做一遍检查
      if (isDonating.value) return; // 防止多次点击
      if (disabledClass.value) return; // 需要当前是可捐贈状态
      if (await highAuthLogin.value.checkIsNeedHighAuthLogin()) {
        await highAuthLogin.value.goHighAuthLogin(props.item);
        return;
      } // 检查高授权
      showLoading();
      currentNGO.value.userTodayDonatedCount = 0;
      isDonating.value = true;
      runQueue(ngo);
    };
    function donationBtnClick() {
      donateStamp(props.item);
    }
    return {
      disabledClass,
      showWxSubscribe,
      tplIds,
      donationBtnClick,
      subSucc(res) {
        biClick('ngo-subscribe.click|订阅点击');
        const hasOneAccept = handleSubscribeRes(res);
        if (hasOneAccept) {
          isSubscribed.value = false;
          biClick('ngo-subscribe.succ|订阅成功');
        }
        donationBtnClick();
      },
      subFail() {
        biClick('ngo-subscribe.fail|订阅失败');
        donationBtnClick();
      },
    };
  },
});
